import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ComplaintTypeSelect from '../ComplaintTypeSelect/ComplaintTypeSelect';
import * as complaintPositionsActions from '../../actions/ComplaintPositions';
import * as complaintPositionActions from '../../actions/ComplaintPosition';
import * as complaintPositionComponentsAction from '../../actions/Components';
import ComplaintPositionForm from './ComplaintPositionForm';
import  * as createXLComplaintActions from '../../actions/CreateXLComplaint';
import {openPurchaseAddressPickerModal} from '../../actions/Modal';
import { changeComplaintType } from '../../actions/Complaint';
import Title from '../base/Title/Title';
import {getComplaintPositionComponentsForCustomer} from '../../reducers/ComplaintPositionsComponents';
import { changePageToCrateComplaintPreview, changePageToCreateComplaintCustomer} from '../../actions/Page';

class SingleComplaintPosition extends Component {

    componentWillMount = () => {
        this.props.changeComplaintType({
            id:1,
            name: "Warranty",
            displayName: "Gwarancja"
        });
    }

    onChange = (name, value) => {
        this.props.updateFormField(name, value);
    }
    
    onFormSubmit = (position) => {
        this.props.submitForm(position);
    }

    onCancelClick = () => {
        this.props.cancelEdit();
    }

    onChangeCheck = (event) => {
        this.onChange(event.target.name,event.target.checked);
    }

    textInputOnChange = (event) => {
        let params = Object.assign({},this.props.XLComplaint);
        params[event.target.name] = event.target.value;
        this.props.setXLComplaintParams(params);
    }

    dateChange = (name,date) => {
        this.onChange(name, date);
    }

    onBackButtonClick = () => this.props.goToCustomerPage();

    onNextButtonClick = () => {
        const id = this.props.complaintPositions.positions.length + 1;
        
        if (this.props.complaintPositions.positions.length == 0) {
            this.props.addComplaintPosition(this.props.complaintPosition,id);
            this.props.goToPreviewPage();
        } else {
            this.props.goToPreviewPage();
        }
        
    };

    onAddPurchaseAddressButtonClick = () => {
        this.props.openPurchaseAddressPickerModal();
    }
/* 
    onComplaintTypeChanged = (e) => {
        this.props.changeComplaintType({
            id:e.target.options[e.target.selectedIndex].getAttribute('data-key'),
            name: e.target.options[e.target.selectedIndex].getAttribute("name"),
            displayName: e.target.options[e.target.selectedIndex].text
        });
        getComplaintPositionComponentsForCustomer(this.props.complaintPositionComponentsForCustomer, this.props.complaintTypeId,this.props.customerTypeId);
    } */

    render() {
        return (
            <div>
                <Title
                id="complaintPositionTitle"
                title={"Dodaj pozycje reklamacji"}
                large />

        {/*         <ComplaintTypeSelect
                    complaintType={this.props.complaint.complaintType}
                    complaintTypes={this.props.util.complaintTypes}
                    onComplaintTypeChanged={this.onComplaintTypeChanged} />  */}
    
                <ComplaintPositionForm
                    complaintType={this.props.complaint.complaintType}
                    componentsToRender={getComplaintPositionComponentsForCustomer(this.props.complaintPositionComponentsForCustomer,this.props.complaintTypeId,this.props.customerTypeId,"ComplaintPosition")}
                    onFormSubmit={this.onFormSubmit}
                    onCancelClick={this.onCancelClick}
                    couriers={this.props.util.couriers}
                    onChange={this.onChange}
                    position={this.props.complaintPosition}
                    quantityCorrectionsProposals={this.props.util.quantityCorrectionsProposals}
                    customer={this.props.customer}
                    
                    util={this.props.util}
                    selectedCompany={this.props.selectedCompany}
                    onNextButtonClick={this.onNextButtonClick}
                    onBackButtonClick={this.onBackButtonClick}
                    purchaseProve={this.props.purchaseProve}
                    textInputOnChange={this.textInputOnChange}
                    onChangeCheck={this.onChangeCheck}
                    onAddPurchaseAddressButtonClick={this.onAddPurchaseAddressButtonClick}
                    customerType={this.props.customerType}
                    />
            </div>
        );
   }
}

SingleComplaintPosition.propTypes = {
    addComplaintPosition:PropTypes.func,
    complaintPosition:PropTypes.object,
    changeComplaintType:PropTypes.func,
    util:PropTypes.object,
    updateFormField:PropTypes.func,
    submitForm:PropTypes.func,
    cancelEdit:PropTypes.func,
    goToCustomerPage:PropTypes.func,
    goToPreviewPage:PropTypes.func,
    complaintPositions:PropTypes.object,
    openPurchaseAddressPickerModal:PropTypes.func,
    complaintPositionComponentsForCustomer:PropTypes.array,
    //complaintTypeId:PropTypes.number,
    customerTypeId:PropTypes.number,
    complaint:PropTypes.object,
    customer:PropTypes.object,
    selectedCompany:PropTypes.object,
    purchaseProve:PropTypes.array,
    customerType:PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        allowMultiplePositionsForComplaint:state.util.allowMultiplePositionsForComplaint,
        customerType: state.customer.type,
        customer: state.customer,
        customerTypeId:state.customer.type.id,
        complaint: state.complaint,
        complaintPosition: state.complaintPosition,
        complaintPositions: state.complaintPositions,
        complaintPositionsComponents: state.complaintPositionsComponents,
        complaintPositionComponentsForCustomer: state.complaintPositionsComponents.complaintPositionComponents,
        complaintTypeId:state.complaint.complaintType.id,
        files: state.complaintPosition.files,
        purchaseProve: state.complaintPosition.purchaseProve,
        selectedCompany:state.company.selectedRow,
        util: state.util
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeComplaintType: (complaintType) => dispatch(changeComplaintType(complaintType)),
        addComplaintPosition: (complaintPosition, id) => dispatch(complaintPositionsActions.AddSingleComplaintPosition(complaintPosition,id)),
        goToPreviewPage: () => dispatch(changePageToCrateComplaintPreview()),
        goToCustomerPage: () => dispatch(changePageToCreateComplaintCustomer()),
        openPurchaseAddressPickerModal: () => dispatch(openPurchaseAddressPickerModal()),
        updateFormField: (name, value) => dispatch(complaintPositionActions.updateField(name, value)),
        submitForm: (complaintPosition) => dispatch(complaintPositionsActions.SaveComplaintPostion(complaintPosition)),
        cancelEdit : () => dispatch(complaintPositionActions.DismissChanges()),
        setXLComplaintParams : (params) => dispatch(createXLComplaintActions.setXLComplaintParams(params))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SingleComplaintPosition);


// WEBPACK FOOTER //
// ./src/components/MenageComplaintPosition/SingleComplaintPosition.js